import { shallowMount } from "@vue/test-utils";
import StepIcon from "@/components/core/StepIcon";

describe("StepIcon component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(StepIcon);
  });

  it("Renders del component StepIcon", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
